import { Injectable } from "@angular/core";
import * as moment from "moment";
import { AnalyticsService } from 'src/app/helpers/analytics.service';
import { AlertController, Platform, PopoverController } from "@ionic/angular";


@Injectable()
export class CommonService {

	constructor(private analytics: AnalyticsService, 
		private platform: Platform){}

    currentMonthFirstDate(){
		var date = new Date();
		var firstDay = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format('YYYYMMDD');
		return firstDay
	}


	numberFormatWithCommaUnit(value) {
		var val, signValue;
		signValue = value
		val = Math.abs(value)
		if (val >= 10000000) {
			val = this.formatNumberComma(this.displayDecimalDigits(val / 10000000)) + ' Cr';

		} else if (val >= 100000) {
			val = this.formatNumberComma(this.displayDecimalDigits(val / 100000)) + ' L';
		}
		else if (val >= 1000) {
			val = this.formatNumberComma(this.displayDecimalDigits(val / 1000)) + ' K';
		}
		else if (val < 100) {
			val = this.displayDecimalDigits(val);
		}
		if (signValue < 0) {
			return '-' + val;
		}
		else {
			return val;
		}
	}

	formatNumberComma(value) {
		var parts = value.toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	
	}

	displayDecimalDigits(value) {
		if (value == 0 || value == Math.round(value)) {
			return value
		}
		else {
			return value.toFixed(2);
		}

	}

	analyticEvent(eventName, method) {
		this.analytics.event(eventName, {
			'method': method
		});
	}

	public isApp() {
		return ((this.platform.is('android') || this.platform.is('ios')) && (!this.platform.is('mobileweb'))) ? true : false;
	}

	inputRestriction(value) {
		if (value.includes('<') || value.includes('>') || value.includes(';') || value.includes('/')) {
			return true
		}
		return false
	}

	public getPlatform() {
		return this.platform.is('android') ? 'Android' : this.platform.is('ios') ? 'IOS' : 'WEB';
	}


}